/*
 * The two player display atoms the design uses wherever a segment or jurisdiction appears
 * (Players list, player detail header and profile, the entry's segment snapshot). Styled from the
 * design tokens — `.pl-seg` and `.pl-juris` in the admin-ui V2 reference — so they read identically
 * across surfaces. Kept in the admin app rather than @cou/admin-ui: they carry player-domain
 * meaning, not generic design-system semantics.
 */

/** The segment as a soft-bordered pill ("Tier 1", "Default", or a raw ref the registry didn't
 * label). An em-dash when the player carried no segment claim at all. */
export function SegmentPill({ children }: { readonly children: string | null }) {
  if (children === null) return <span className="text-ink-4">—</span>;
  return (
    <span className="inline-flex items-center whitespace-nowrap rounded-pill border-[0.5px] border-line-strong bg-surface-muted px-2.5 py-[3px] font-ui text-[12px] font-semibold leading-[1.3] text-ink-2">
      {children}
    </span>
  );
}

/** The jurisdiction state as a small mono accent badge ("NJ"). Em-dash when unknown. */
export function JurisdictionBadge({ children }: { readonly children: string | null }) {
  if (children === null) return <span className="text-ink-4">—</span>;
  return (
    <span className="inline-flex items-center rounded-chip bg-accent-soft px-[9px] py-[3px] font-mono text-[11.5px] font-semibold leading-[1.3] tracking-[0.03em] text-accent">
      {children}
    </span>
  );
}
